<div class="auth-token mm-page">
  <header class="qa-at-header">
    <h2>{{_(KEYS.AUTH_TOKEN.AUTH_TOKEN)}}</h2>
    <p>{{_(KEYS.AUTH_TOKEN.SUBTITLE)}}</p>
  </header>

  <!-- the browser must not fill in the logged in user here: autocomplete off / new-password -->
  <form [formGroup]="authTokenForm" class="card qa-at-card" autocomplete="off" (ngSubmit)="authTokenForm.valid && onSubmit()">
    <div class="card-body">
      <div class="qa-at-fields">
        <div class="form-group">
          <label for="email">{{_(KEYS.AUTH_TOKEN.USERNAME)}}</label>
          <input class="form-control" id="email" placeholder="{{_(KEYS.AUTH_TOKEN.ENTER_USERNAME)}}" formControlName="email" name="email"
                 autocomplete="off" spellcheck="false">
          <div class="invalid-feedback display" *ngIf="email.dirty && email.errors?.email">{{_(KEYS.AUTH_TOKEN.ENTER_EMAIL)}}</div>
        </div>

        <div class="form-group">
          <label for="password">{{_(KEYS.AUTH_TOKEN.PASSWORD)}}</label>
          <input type="password" class="form-control" id="password" placeholder="{{_(KEYS.AUTH_TOKEN.ENTER_PASSWORD)}}" formControlName="password"
                 name="password" autocomplete="new-password">
          <div class="invalid-feedback display" *ngIf="password.errors?.passwordPolicy">{{_(passwordPolicy?.hint)}}</div>
        </div>

        <div class="form-group qa-at-wide">
          <label for="secret">{{_(KEYS.AUTH_TOKEN.SHARED_SECRET)}}</label>
          <input type="password" class="form-control" id="secret" placeholder="{{_(KEYS.AUTH_TOKEN.ENTER_SHARED_SECRET)}}" formControlName="secret"
                 name="secret" autocomplete="new-password">
        </div>
      </div>

      <button type="submit" class="btn btn-primary" [disabled]="!authTokenForm.valid">
        <i class="fa fa-key" aria-hidden="true"></i> {{_(KEYS.AUTH_TOKEN.CREATE_TOKEN)}}
      </button>
    </div>

    <!-- result: the token as code with a copy button -->
    <div class="qa-at-result" *ngIf="authToken" [class.qa-at-invalid]="!isValidAuthToken" role="status" aria-live="polite">
      <div class="qa-at-result-head">
        <span class="qa-at-state">
          <i class="fa" [ngClass]="isValidAuthToken ? 'fa-check-circle' : 'fa-times-circle'" aria-hidden="true"></i>
          {{isValidAuthToken ? _(KEYS.AUTH_TOKEN.TOKEN_VALID) : _(KEYS.AUTH_TOKEN.INVALID_AUTH_TOKEN)}}
        </span>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onCopyToken()" *ngIf="isValidAuthToken">
          <i class="fa" [ngClass]="copied ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>
          {{copied ? _(KEYS.AUTH_TOKEN.COPIED) : _(KEYS.AUTH_TOKEN.COPY)}}
        </button>
      </div>
      <code class="qa-at-token">{{authToken}}</code>
    </div>
  </form>
</div>
